//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    show: {
      type: Boolean,
      default: true
    },
    placeholderTxt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: ''
    }
  },
  methods: {
    onSubmit () {
      if (this.value.length > 0) {
        this.$emit('search', this.value)
      } else {
        this.$emit('search', false)
      }
    },
    onSearch(e){
      if(e.keyCode == 13) this.onSubmit()
    },
    formSubmit(){
      return false;
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/build922/views/components/search/index.vue